import { create } from "zustand";
import { persist } from "zustand/middleware";
import { DEFAULT_CREATORS, type Creator } from "./creators.js";
import type { Profile } from "../settings/profileStore.js";

/**
 * Who each profile follows on Social (owner, 2026-10-07: Social is linked to
 * the app's profiles). Kept on this device like the rest of a profile.
 *
 * A profile that has never chosen follows the starting list, DEFAULT_CREATORS;
 * a Kids profile starts with nobody, since these channels are made for adults.
 * Choosing (a Settings screen, next) stores the profile's own list here.
 */
interface SocialStore {
  /** profile id → the creators it follows, once it has chosen. */
  lists: Record<string, Creator[]>;
  setCreators: (profileId: string, creators: Creator[]) => void;
}

export const useSocialStore = create<SocialStore>()(
  persist(
    (set) => ({
      lists: {},
      setCreators: (profileId, creators) => set((state) => ({ lists: { ...state.lists, [profileId]: creators } })),
    }),
    { name: "slique-social", version: 1 },
  ),
);

/** The creators a profile follows: its own list, else the starting one (none for Kids). */
export function creatorsFor(profile: Pick<Profile, "id" | "isKids"> | undefined, lists: Record<string, Creator[]>): Creator[] {
  if (!profile) return DEFAULT_CREATORS;
  return lists[profile.id] ?? (profile.isKids ? [] : DEFAULT_CREATORS);
}
